import React from "react";
import { Link } from "react-router-dom";
import visaGroup from "../../../images/coding-camp/6C8A6145.jpg";
import "./VisaHighlightBanner.css";

const VisaHighlightBanner = () => (
  <section className="visa-highlight-banner" aria-labelledby="visa-highlight-title">
    <div className="visa-highlight-copy">
      <p>Young People Coding &amp; AI Camp</p>
      <h2 id="visa-highlight-title">Their work had a room.</h2>
      <span>See how our young people shared their projects during a visit to Visa Europe HQ.</span>
      <Link to="/community-projects/ncil-youth-coding-camp#visa-career-day">Read the story</Link>
    </div>
    <img src={visaGroup} alt="Coding Camp cohort gathered inside Visa Europe HQ" loading="lazy" />
  </section>
);

export default VisaHighlightBanner;
